export const environment = {
	production: true,
	server_URL: 'https://longevitysoftware.com/LongevityWebAPIV2', 
	router_prefix: '/api/v1' 
};